export const iconsInRowColId = 'iconsInRow';

const defaultIgnoredColumns = [
    iconsInRowColId,
    'autorun',
    'involved_incidents'
];

// this function checks what column of a grid you have clicked on, and if it goes ignored.
export const shouldConsiderRowEventCallback = (
    params,
    ignoredColumns = defaultIgnoredColumns
) => {
    const focusedCell = params.api.getFocusedCell();
    // console.log('shouldConsiderRowEventCallback',{ params, ignoredColumns, focusedCell });
    try {
        if (focusedCell) {
            const colId = focusedCell.column.colDef.colId || focusedCell.column.colId;
            // console.debug({colId});
            if (colId) {
                return !ignoredColumns.includes(colId);
            }
        }
        return true;
    } catch (exception) {
        console.error(exception);
    }
    return false;
};


export const iconsAreFrozenKey = 'iconsAreFrozen';

// temporary mark:
export const freezeIconsIn = (row, bool) => {
    const rowData = row.data;
    const key = iconsAreFrozenKey;
    if (bool) {
        rowData[key] = true;
    } else {
        delete rowData[key];
    }
    row.setData(rowData); // (redraw)
};

export const frozenCheck = row => row.data?.iconsAreFrozen;